import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as strings from '../../../base/common/strings.js';
import { Range } from '../../common/core/range.js';
import { CancellationTokenSource } from '../../../base/common/cancellation.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { EditorKeybindingCancellationTokenSource } from './keybindingCancellation.js';
export var EditorState = /*#__PURE__*/function () {
  function EditorState(editor, flags) {
    _classCallCheck(this, EditorState);

    this.flags = flags;

    if ((this.flags & 1
    /* Value */
    ) !== 0) {
      var model = editor.getModel();
      this.modelVersionId = model ? strings.format('{0}#{1}', model.uri.toString(), model.getVersionId()) : null;
    } else {
      this.modelVersionId = null;
    }

    if ((this.flags & 4
    /* Position */
    ) !== 0) {
      this.position = editor.getPosition();
    } else {
      this.position = null;
    }

    if ((this.flags & 2
    /* Selection */
    ) !== 0) {
      this.selection = editor.getSelection();
    } else {
      this.selection = null;
    }

    if ((this.flags & 8
    /* Scroll */
    ) !== 0) {
      this.scrollLeft = editor.getScrollLeft();
      this.scrollTop = editor.getScrollTop();
    } else {
      this.scrollLeft = -1;
      this.scrollTop = -1;
    }
  }

  _createClass(EditorState, [{
    key: "_equals",
    value: function _equals(other) {
      if (!(other instanceof EditorState)) {
        return false;
      }

      var state = other;

      if (this.modelVersionId !== state.modelVersionId) {
        return false;
      }

      if (this.scrollLeft !== state.scrollLeft || this.scrollTop !== state.scrollTop) {
        return false;
      }

      if (!this.position && state.position || this.position && !state.position || this.position && state.position && !this.position.equals(state.position)) {
        return false;
      }

      if (!this.selection && state.selection || this.selection && !state.selection || this.selection && state.selection && !this.selection.equalsRange(state.selection)) {
        return false;
      }

      return true;
    }
  }, {
    key: "validate",
    value: function validate(editor) {
      return this._equals(new EditorState(editor, this.flags));
    }
  }]);

  return EditorState;
}();
/**
 * A cancellation token source that cancels when the editor changes as expressed
 * by the provided flags
 * @param range If provided, changes in position and selection within this range will not trigger cancellation
 */

export var EditorStateCancellationTokenSource = /*#__PURE__*/function (_EditorKeybindingCanc) {
  _inherits(EditorStateCancellationTokenSource, _EditorKeybindingCanc);

  var _super = _createSuper(EditorStateCancellationTokenSource);

  function EditorStateCancellationTokenSource(editor, flags, range, parent) {
    var _this;

    _classCallCheck(this, EditorStateCancellationTokenSource);

    _this = _super.call(this, editor, parent);
    _this.editor = editor;
    _this._listener = new DisposableStore();

    if (flags & 4
    /* Position */
    ) {
      _this._listener.add(editor.onDidChangeCursorPosition(function (e) {
        if (!range || !Range.containsPosition(range, e.position)) {
          _this.cancel();
        }
      }));
    }

    if (flags & 2
    /* Selection */
    ) {
      _this._listener.add(editor.onDidChangeCursorSelection(function (e) {
        if (!range || !Range.containsRange(range, e.selection)) {
          _this.cancel();
        }
      }));
    }

    if (flags & 8
    /* Scroll */
    ) {
      _this._listener.add(editor.onDidScrollChange(function (_) {
        return _this.cancel();
      }));
    }

    if (flags & 1
    /* Value */
    ) {
      _this._listener.add(editor.onDidChangeModel(function (_) {
        return _this.cancel();
      }));

      _this._listener.add(editor.onDidChangeModelContent(function (_) {
        return _this.cancel();
      }));
    }

    return _this;
  }

  _createClass(EditorStateCancellationTokenSource, [{
    key: "dispose",
    value: function dispose() {
      this._listener.dispose();

      _get(_getPrototypeOf(EditorStateCancellationTokenSource.prototype), "dispose", this).call(this);
    }
  }]);

  return EditorStateCancellationTokenSource;
}(EditorKeybindingCancellationTokenSource);
/**
 * A cancellation token source that cancels when the provided model changes
 */

export var TextModelCancellationTokenSource = /*#__PURE__*/function (_CancellationTokenSou) {
  _inherits(TextModelCancellationTokenSource, _CancellationTokenSou);

  var _super2 = _createSuper(TextModelCancellationTokenSource);

  function TextModelCancellationTokenSource(model, parent) {
    var _this2;

    _classCallCheck(this, TextModelCancellationTokenSource);

    _this2 = _super2.call(this, parent);
    _this2._listener = model.onDidChangeContent(function () {
      return _this2.cancel();
    });
    return _this2;
  }

  _createClass(TextModelCancellationTokenSource, [{
    key: "dispose",
    value: function dispose() {
      this._listener.dispose();

      _get(_getPrototypeOf(TextModelCancellationTokenSource.prototype), "dispose", this).call(this);
    }
  }]);

  return TextModelCancellationTokenSource;
}(CancellationTokenSource);
export var StableEditorScrollState = /*#__PURE__*/function () {
  function StableEditorScrollState(_visiblePosition, _visiblePositionScrollDelta, _cursorPosition) {
    _classCallCheck(this, StableEditorScrollState);

    this._visiblePosition = _visiblePosition;
    this._visiblePositionScrollDelta = _visiblePositionScrollDelta;
    this._cursorPosition = _cursorPosition;
  }

  _createClass(StableEditorScrollState, [{
    key: "restore",
    value: function restore(editor) {
      if (this._visiblePosition) {
        var visiblePositionScrollTop = editor.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
        editor.setScrollTop(visiblePositionScrollTop + this._visiblePositionScrollDelta);
      }
    }
  }, {
    key: "restoreRelativeVerticalPositionOfCursor",
    value: function restoreRelativeVerticalPositionOfCursor(editor) {
      var currentCursorPosition = editor.getPosition();

      if (!this._cursorPosition || !currentCursorPosition) {
        return;
      }

      var offset = editor.getTopForLineNumber(currentCursorPosition.lineNumber) - editor.getTopForLineNumber(this._cursorPosition.lineNumber);
      editor.setScrollTop(editor.getScrollTop() + offset);
    }
  }], [{
    key: "capture",
    value: function capture(editor) {
      var visiblePosition = null;
      var visiblePositionScrollDelta = 0;

      if (editor.getScrollTop() !== 0) {
        var visibleRanges = editor.getVisibleRanges();

        if (visibleRanges.length > 0) {
          visiblePosition = visibleRanges[0].getStartPosition();
          var visiblePositionScrollTop = editor.getTopForPosition(visiblePosition.lineNumber, visiblePosition.column);
          visiblePositionScrollDelta = editor.getScrollTop() - visiblePositionScrollTop;
        }
      }

      return new StableEditorScrollState(visiblePosition, visiblePositionScrollDelta, editor.getPosition());
    }
  }]);

  return StableEditorScrollState;
}();